export class AddFileDto {
    name?: string;
    url?: string;
    size?: number;
    mimeType?: string;

    documentTypeId?: string;
}